import { createFileRoute } from '@tanstack/react-router'

interface IErrorReportsSearch {
  page?: number
  resolved?: string
}

export const Route = createFileRoute('/_authenticated/error-reports')({
  validateSearch: (search: Record<string, unknown>): IErrorReportsSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
    resolved:
      typeof search.resolved === 'string' && ['unresolved', 'resolved'].includes(search.resolved)
        ? search.resolved
        : undefined,
  }),
})
